import { ImResponse, omsV2Client, resolve } from '.';

export interface ReceptionScoreState {
  conversationId: string;
  stateRevision: number;
  autoStatus: string;
  autoDueAt: number | null;
  activeInvitation: {
    inviteMsgId: string;
    status: string;
    sendMode: string;
    expiresAt: number | null;
  } | null;
}
export interface ReceptionScoreOperation {
  requestId: string;
  operationStatus: 'PROCESSING' | 'UNKNOWN' | 'SUCCEEDED' | 'FAILED';
  errorCode: string;
  invitationStatus: string | null;
}
export const getReceptionScoreState = (id: string) =>
  resolve(
    omsV2Client.get<ImResponse<ReceptionScoreState>>(
      `/reception-score/conversations/${id}/state`,
      { timeout: 15000 },
    ),
  );
export const getReceptionScoreOperation = (id: string) =>
  resolve(
    omsV2Client.get<ImResponse<ReceptionScoreOperation>>(`/reception-score/operations/${id}`, {
      timeout: 15000,
    }),
  );
export const sendReceptionScoreInvitation = (body: {
  requestId: string;
  conversationId: string;
  expectedStateRevision: number;
}) =>
  resolve(
    omsV2Client.post<ImResponse<ReceptionScoreOperation>>(
      '/reception-score/invitations',
      body,
      { timeout: 25000 },
    ),
  );
